export const environment = {
  production: true,
  development: false,
  test: false,
  authorizeProspectBrands: '[\"VYV\", \"HM\", \"MGEN\", \"MNT\"]',
  product: 'HC',
  brand: 'VYV',
  apiV2RootUrl: 'https://tst.assurance.vyv-conseil.fr/api/',
  baseUrl: 'https://tst.assurance-habitation.vyv-conseil.fr/',
  matomotoKey: 'CHANGEME',
  appInsightsKey: 'e9c64840-c6be-4cce-b997-91dd6be90ca1',
  assGarantie:
    'https://saboiartbackofficera6ej.blob.core.windows.net/public/Plaquette_Assurance_Protection_Juridique_Tableau%20des%20garanties.pdf',
  matomoSiteId: 6,
  matomoHostUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/',
  matomoScriptUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/js/container_682wvypB.js',
  urlWarranty: {
    assConfort:
      'https://saboiartbackofficera6ej.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_Confort_Tableau%20des%20garanties.pdf',
    assMetropole:
      'https://saboiartbackofficera6ej.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_{0}_Tableau%20des%20garanties.pdf',
    assSolidaire:
      'https://saboiartbackofficera6ej.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_Solidaire_Tableau%20des%20garanties.pdf',
  },
  modeleCourrierResiliation: 'https://saboiartbackofficera6ej.blob.core.windows.net/public/ModeleCourrier.docx',
  msalConfig: {
    auth: {
      clientId: '58b0cd73-5302-43d5-b494-4344ed4954b3',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
      redirectUri: 'https://tst.assurance-habitation.vyv-conseil.fr/',
    },
  },
  apiConfig: {
    scopes: ['api://boiard-tst-back-office/Read.All', 'api://boiard-tst-back-office/Write.All'],
    uri: 'https://tst.assurance.vyv-conseil.fr/api/',
  },
  url_espace_adherent: 'https://tst.assurance.vyv-conseil.fr/mon-espace/',
  googleTagManagerId: 'GTM-M2XCS4XC',
  skeepersTagId: '0ca9a77d9faddd0653a92063233c1633-3921',
  mrhStudentWorkflowUrl: 'https://tst.assurance-habitation.vyv-conseil.fr/MRH/',
};
